import { UniqueItem } from './unique-item.interface';
export class CountSummary<T extends UniqueItem> {
    count: number;
    item: T;
}
